import React, { useEffect, useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import "./ShowcaseActions.scss";

import editIcon from "../img/edit.png";
import shareIcon from "../img/share.png";
import deleteIcon from "../img/delete.png";

const ShowcaseActions = ({ onClose, isOwner, onEdit, onShare, onDeleteShowcase }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const sheetRef = useRef(null);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    const originalWidth = document.body.style.width;

    const html = document.documentElement;
    const originalHtmlOverflow = html.style.overflow;

    html.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      html.style.overflow = originalHtmlOverflow || "";
      document.body.style.overflow = originalOverflow || "";
      document.body.style.position = originalPosition || "";
      document.body.style.top = originalTop || "";
      document.body.style.width = originalWidth || "";

      window.scrollTo(0, scrollY);
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => firstFocusRef.current?.focus(), 10);
    const onKey = (e) => {
      if (e.key === "Escape") handleRequestClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(t);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  const handleRequestClose = useCallback(() => {
    if (isClosing) return;
    setIsClosing(true);
    setIsOpen(false);
    setTimeout(() => onClose?.(), 240);
  }, [isClosing, onClose]);

  const stop = (e) => e.stopPropagation();

  const handleDelete = async () => {
    if (!isOwner) return;
    if (!onDeleteShowcase) {
      alert("Внутрішня помилка: onDeleteShowcase не передано у ShowcaseActions.");
      return;
    }
    if (isDeleting) return;

    const ok = window.confirm("Точно видалити вітрину? Дію неможливо скасувати.");
    if (!ok) return;

    try {
      setIsDeleting(true);
      await onDeleteShowcase();
      handleRequestClose();
    } catch (e) {
      console.error("[UI] Delete failed:", e);
      alert(e?.message || "Не вдалося видалити вітрину");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div
      className={`sa-overlay ${isOpen ? "is-open" : ""} ${isClosing ? "is-closing" : ""}`}
      onClick={handleRequestClose}
      role="dialog"
      aria-modal="true"
      aria-label="Дії вітрини"
    >
      <div className={`sa-modal ${isOpen ? "is-open" : ""}`} onClick={stop} role="document" ref={sheetRef}>
        {isOwner ? (
          <>
            <button ref={firstFocusRef} onClick={onEdit} className="sa-btn" type="button">
              <img src={editIcon} alt="Редагувати" className="sa-icon no-invert" />
              Редагувати вітрину
            </button>

            <button className="sa-btn" onClick={onShare} type="button">
              <img src={shareIcon} alt="Поділитись" className="sa-icon sa-icon--share" />
              Поділитись вітриною
            </button>

            <button
              className="sa-btn danger"
              onClick={handleDelete}
              disabled={isDeleting}
              aria-busy={isDeleting ? "true" : "false"}
              type="button"
            >
              <img src={deleteIcon} alt="Видалити" className="sa-icon" />
              {isDeleting ? "Видаляємо..." : "Видалити вітрину"}
            </button>
          </>
        ) : (
          <>
            <button ref={firstFocusRef} className="sa-btn" onClick={onShare} type="button">
              <img src={shareIcon} alt="Поділитись" className="sa-icon sa-icon--share" />
              Поділитись вітриною
            </button>
          </>
        )}
      </div>
    </div>
  );
};

ShowcaseActions.propTypes = {
  onClose: PropTypes.func,
  isOwner: PropTypes.bool,
  onEdit: PropTypes.func,
  onShare: PropTypes.func,
  onDeleteShowcase: PropTypes.func,
};

export default ShowcaseActions;
